<template>
    <div v-if="news.length > 0" class="news">
      <a v-for="(detail, index) of news" :key="index" :href="'/news/'+detail.slug">
        <article class="item font-proxima md:flex align-center">
            <img
              class="thumbnail eventImage"
              :src="image(detail.get_image)"
              alt=""
            />
          <div class="inner">
            <h3 class="text-black font-proxima">{{detail.title }}</h3>
            <p class="font-proxima">{{ dateToString(detail.published_date) }}</p>
            <div class="flex align-center">
              <a :href="'/news/'+detail.slug" class="readmore font-proxima">Read more</a>
            </div>
          </div>
        </article>
      </a>

      <div v-if="hasMoreToLoad && news.length > 0" >
          <a @click="loadMore" class="flex align-center text-black font-proxima mx-auto button">
            Load More <span class="ml-1">+</span>
          </a>
      </div>


    </div>
    
    <div v-else class="events">
      <p>No events found.</p>
    </div>


</template>
<script>
export default {
  data() {
    return {
      news: [],
      locations: [],
      isClose: true,
      hasMoreToLoad: false,
      isLoadMoreClicked: false,
      currentPage: 1,
      metas: [],
      error: "",
    };
  },

  mounted() {
    this.getNews("", false);
  },

  methods: {
    loadMore () {
      this.isLoadMoreClicked = true
      let pageNumber = 1
      pageNumber = this.currentPage + 1
      this.getNews({
        isPaginate: 1,
        page:pageNumber
        })
    },

    getNews(params) {
      const { ispaginate, page } = params;
      let eventUrl = "/api/news";
      window.axios
        .get(eventUrl, {
          params: {
            page
          }
        })
        .then((response) => {
          if (page > this.currentPage) {
            
            this.news  = [...this.news, ...response.data.data.data]
          } else {
            this.news = response.data.data.data
          }
          console.log("page ==>", response.data.data.last_page)
          this.hasMoreToLoad= response.data.data.last_page > this.currentPage ? true : false
          this.currentPage = response.data.data.current_page
          this.metas = response.data.data.meta

        })
        .catch((error) => {
          this.error = error.response.data.message;
          console.log(error);
        });
    },

    dateToString(myDate) {
      const convertDate = new Date(myDate);
      const currentDate = convertDate.toDateString();
      return currentDate;
    },

    image(myImage) {
      console.log(JSON.stringify(myImage))
      if (myImage.length > 0) {
        let paths = []
        myImage.map((image) => {
          if(image.field_name === 'small') {
           paths.push(image.path);
          }
        })
       return paths.pop();
      } else {
        return "https://via.placeholder.com/270x175";
      }
    },
    
  },
};
</script>
<style scoped>
.eventImage {
  width: 270px;
  height: 175px;
}

.actions .toggler {
  width: 100%;
  text-align: center;
  padding: 10px 20px;
  border: 2px solid #ededed;

  font-family: "proxima-nova", "Arial", "Helvetica Neue", "Helvetica",
    sans-serif;

  cursor: pointer;
  transition: all 0.3s ease;
}

.toggler:hover {
  color: #0E7F86;
  border: 2px solid #0E7F86;
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/News.vue